// extracted by mini-css-extract-plugin
export default {"content":"Gb49d05","shippingDetail":"Gd1df3b"};